const ratingSchema = {
  '@context': 'https://schema.org',
  '@type': 'Product',
  name: 'Create online course websites and mobile apps',
  description:
    'Create fully customizable websites and mobile apps for your online course. Launch white-labeled websites and own branded mobile apps without any coding. Try for free now!',
  image: 'https://graphy.com/images/graphy-brand-logo.svg',
  brand: 'Graphy',
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '5',
    bestRating: '5',
    worstRating: '4.4',
    ratingCount: '194'
  }
};

export default function RatingSchema() {
  return (
    <script
      key={`JSON-rating`}
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(ratingSchema)
      }}
    />
  );
}
